import axios from "axios";

export default {
  namespaced: true,
  state: {
    glledgers: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    glledgersMessage: ''
  },
  mutations: {
    RECEIVED_GLLEDGERS(state, payload) {
      state.glledgers = payload;
      state.isReceiving = false;
    },
    RECEIVING_GLLEDGERS(state) {
      state.isReceiving = true;
    },
    RECEIVED_GLLEDGER(state, payload) {
      state = Object.assign(state, {
        glledgers: [...state.glledgers, payload],
        isReceiving: false,
      })
    },
    RECEIVING_GLLEDGER(state) {
      state.isReceiving = true;
    },
    UPDATED_GLLEDGER(state, payload) {
      let index = state.glledgers.findIndex(glledger => glledger._id === payload._id);
      state = Object.assign(state, {
        glledgers: state.glledgers.map((glledger, i) => {
          if (i === index) {
            return Object.assign({}, glledger, payload);
          }
          return glledger;
        }),
        isUpdating: false,
        glledgersMessage: 'GLLedgers has been updating!',
      })
    },
    UPDATING_GLLEDGER(state) {
      state.isUpdating = true;
    },
    DELETED_GLLEDGER(state, payload) {
      let indexToDelete = state.glledgers.findIndex(glledger => glledger._id === payload._id);
      let glledgers = [...state.glledgers];
      glledgers.splice(indexToDelete, 1);
      state = Object.assign(state, {
        glledgers: [...glledgers],
        isDeleting: false,
        idToDelete: null,
        glledgersMessage: 'GLLedger has been Deleted!',
      });
    },
    DELETING_GLLEDGER(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getGLLedgersRequest({dispatch}) {
      dispatch("receivingGLLedgers");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/gl-ledgers';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveGLLedgers", res.data);
      })
    },
    async updateGLLedgerRequest({dispatch}, payload) {
      dispatch("updatingGLLedger");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/gl-ledger/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateGLLedger", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async insertGLLedgerRequest({dispatch}, payload) {
      dispatch("receivingGLLedgers");
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let url = 'https://api.accountxc.com:3100/insert/gl-ledger';
      let data = payload;
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveGLLedger", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deleteGLLedgerRequest({dispatch}, payload) {
      dispatch("deletingGLLedger", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/gl-ledger/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteGLLedger", {_id: payload._id});
      })
    },
    receiveGLLedgers({commit}, payload) {
      commit("RECEIVED_GLLEDGERS", payload)
    },
    receivingGLLedgers({commit}) {
      commit("RECEIVING_GLLEDGERS")
    },
    receiveGLLedger({commit}, payload) {
      commit("RECEIVED_GLLEDGER", payload)
    },
    receivingGLLedger({commit}) {
      commit("RECEIVING_GLLEDGER")
    },
    updateGLLedger({commit}, payload) {
      commit("UPDATED_GLLEDGER", payload)
    },
    updatingGLLedger({commit}) {
      commit("UPDATING_GLLEDGER")
    },
    deleteGLLedger({commit}, payload) {
      commit("DELETED_GLLEDGER", payload)
    },
    deletingGLLedger({commit}, payload) {
      commit("DELETING_GLLEDGER", payload)
    }
  },
};
